import application from "stimulus_application";
import RevealTocController from "./reveal_toc_controller";
import "./reveal_toc.css";

application.register("reveal-toc", RevealTocController);
